//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';

import { NavDropdown } from '@legacy-components/nav3/navigation-menus/NavDropdown';
import { NavDropdownItem } from '@legacy-components/nav3/navigation-menus/NavDropdownItem';
import { NAV_DROPDOWN_ITEMS_TRACKING_ID } from '@legacy-components/nav3/navigation-menus/constants/NavMenuItemConstants';

export const MediaMenu = () => {
  return (
    <NavDropdown>
      <NavDropdownItem
        primary='Library'
        state='library.all-media'
        trackingId={NAV_DROPDOWN_ITEMS_TRACKING_ID.LIBRARY_DROPDOWN}
      />
      <NavDropdownItem
        primary='Share'
        state='syndication.summary'
        trackingId={NAV_DROPDOWN_ITEMS_TRACKING_ID.SHARE_DROPDOWN}
      />
    </NavDropdown>
  );
};
